import { baseApi } from './baseApi';

export interface RegisterPushSubscriptionRequest {
  endpoint: string;
  p256dh: string;
  auth: string;
  deviceInfo?: string;
}

/**
 * Evento SignalR "OrderReady" emitido por el backend cuando cocina marca
 * una orden como lista. Mismo shape que OrderReadyNotificationDto (camelCase).
 */
export interface OrderReadyEvent {
  kitchenOrderId: string;
  orderId: string;
  restaurantId: string;
  orderNumber: number;
  /** "DineIn" | "TakeOut" | "Delivery" — en llevar/domicilio tableNumber trae el cliente */
  orderType?: string;
  tableNumber: string;
  areaName: string;
  waiterId?: string | null;
  waiterName: string;
  itemsSummary: string;
  readyAt: string;
}

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // publicKey viene null cuando el servidor no tiene VAPID configurado
    getPushPublicKey: builder.query<{ publicKey: string | null }, void>({
      query: () => ({ url: '/push/public-key' }),
    }),
    subscribePush: builder.mutation<void, RegisterPushSubscriptionRequest>({
      query: (body) => ({
        url: '/push/subscriptions',
        method: 'POST',
        body,
      }),
    }),
    unsubscribePush: builder.mutation<void, { endpoint: string }>({
      query: (body) => ({
        url: '/push/subscriptions/unsubscribe',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetPushPublicKeyQuery,
  useSubscribePushMutation,
  useUnsubscribePushMutation,
} = notificationsApi;
